
import React, { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomEmptyView from "../../../Components/CustomEmptyView";
import Strings from "../../../Config/Strings";
import { deleteProductMetalDetailsAPI } from "../../../Store/Action/productMetalAction";
import Colors from "../../../theme/Colors";
import ProductMetalTableBody from "./Controls/ProductMetalTableBody";
import ProductMetalTableHeader from "./Controls/ProductMetalTableHeader";
import Pagination from "../../../Components/Pagination";

const MetalTable = ({
  productMetal,
  page,
  rowsPerPage,
  handleChangePage,
  handleChangeRowsPerPage,
  totalItems,
  rowsPerPageOptions,
  searchValue,
  onSearchChange,
  rowsPerPageLabel,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [userIdToDelete, setUserIdToDelete] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);


  // Calculate total pages based on totalItems and rowsPerPage
  const totalPages = Math.ceil(totalItems / rowsPerPage);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    handleChangePage(null, newPage - 1); // Adjusting index as per 0-based index system
  };

  const handleOpen = useCallback(() => setModalVisible(true), []);
  const handleClose = useCallback(() => setModalVisible(false), []);
  const handleCancelDelete = useCallback(() => {
    setShowDeleteModal(false);
  }, []);

  const handleShowDeleteModal = useCallback((productId) => {
    setUserIdToDelete(productId);
    setShowDeleteModal(true);
  }, []);


  const onViewProductMetalDetails = useCallback(
    (prodMetalId) => {
      navigate(`/productMetal/${prodMetalId?.id}`, { state: { prodMetalId } });
    },
    [navigate]
  );

  const onEditProductMetalDetails = useCallback(
    (prodMetal) => {
      navigate(`/productMetal/edit`, { state: { prodMetal } });
    },
    [navigate]
  );

  const handleDeleteUser = async () => {
    setLoading(true);
    try {
      await dispatch(
        deleteProductMetalDetailsAPI(userIdToDelete, (isSuccess, response) => {
          setShowDeleteModal(false);
          setLoading(false);
          if (isSuccess?.status === true) {
            toast.success("Product Metal Updated Successfully");
            setTimeout(() => {
              window.location.reload();
            }, 400);
          } else {
            const errorMessage =
              response?.error?.message || Strings.somethingWentWrongError;
            toast.error(errorMessage);
          }
        })
      );
    } catch (error) {
      console.log("Error dispatching addProducts:", error);
      setLoading(false);
      toast.error(Strings.somethingWentWrongError);
    }
  };

  return (
    <div style={mainContainer}>
      <div style={outerWrapper}>
        <div style={tableWrapper}>
          <div style={{ height: "92%", minWidth: "110%" }}>
            {productMetal?.length === 0 ||
            productMetal?.length === undefined ||
            productMetal?.length === null ? (
              <div style={{ width: "70vw" }}>
                <CustomEmptyView />
              </div>
            ) : (
              <>
                <table style={table}>
                  <ProductMetalTableHeader />
                  <ProductMetalTableBody
                    prodMetalDetails={productMetal}
                    onViewProductMetalDetails={onViewProductMetalDetails}
                    onEditProductMetalDetails={onEditProductMetalDetails}
                    handleShowDeleteModal={handleShowDeleteModal}
                  />
                </table>
              </>
            )}
          </div>

          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  );
};

const mainContainer = {
  borderRadius: "10px",
  height: "78%",
  marginTop: "25px",
  marginLeft: '22px',
  width: '97%',
};

const outerWrapper = {
  borderRadius: "4px",
  boxShadow: "0px 0px 3px #e6e6e6",
  maxWidth: "100%",
  height: "100%",
  backgroundColor: Colors.white,
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const tableWrapper = {
  overflowY: "scroll",
  overflowX: "hidden",
  height: "100%",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
};

const table = {
  minWidth: "100%",
  borderCollapse: "separate",
  borderSpacing: "0px",
};

export default MetalTable;
